/* AYON Wellness v2 — Main JS */

// Mobile menu
const burger = document.getElementById('navBurger');
const mMenu = document.getElementById('mobileMenu');
if (burger && mMenu) {
  burger.addEventListener('click', () => mMenu.classList.toggle('open'));
  mMenu.querySelectorAll('a').forEach(l => l.addEventListener('click', () => mMenu.classList.remove('open')));
}

// FAQ accordion
function toggleFaq(el) {
  const a = el.nextElementSibling;
  const isOpen = a.classList.contains('open');
  document.querySelectorAll('.faq-a').forEach(x => x.classList.remove('open'));
  document.querySelectorAll('.faq-q').forEach(x => x.classList.remove('open'));
  if (!isOpen) { a.classList.add('open'); el.classList.add('open'); }
}

// Cart notice
function showCartNotice() {
  const n = document.getElementById('cartNotice');
  if (!n) return;
  n.classList.add('show');
  setTimeout(() => n.classList.remove('show'), 2500);
}

// Ajax Add to Cart
async function addToCartShopify(btn) {
  const id = btn.getAttribute('data-variant-id');
  if (!id) { showCartNotice(); return; }
  btn.textContent = 'Adding...';
  btn.disabled = true;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: 1 })
    });
    if (res.ok) {
      showCartNotice();
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
    }
  } catch (e) { console.error(e); }
  btn.textContent = 'Add to Cart';
  btn.disabled = false;
}

// Quantity control on product page
function changeQty(d) {
  const i = document.getElementById('qtyInput');
  if (!i) return;
  const v = parseInt(i.value) + d;
  if (v >= 1 && v <= 99) i.value = v;
}

// ─────────────────────────────────────────────────────────
// WHATSAPP CLICK TRACKING — Meta Pixel + Google Ads
// Fires on every WhatsApp button/link click across the store
// ─────────────────────────────────────────────────────────
function trackWhatsAppClick(label) {
  // Meta Pixel: Contact (WhatsApp)
  if (typeof fbq !== 'undefined') {
    fbq('track', 'Contact', { content_name: label || 'WhatsApp Click' });
    fbq('trackCustom', 'WhatsAppClick', { label: label || 'general' });
  }
  // Google Ads: generate_lead event
  if (typeof gtag !== 'undefined') {
    gtag('event', 'generate_lead', {
      event_category: 'WhatsApp',
      event_label: label || 'WhatsApp Click'
    });
  }
}

// Attach to all WhatsApp links automatically
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href*="wa.me"]').forEach(function(link) {
    link.addEventListener('click', function () {
      const label = this.textContent.trim() || this.title || 'whatsapp_link';
      trackWhatsAppClick(label);
    });
  });
});

// ─────────────────────────────────────────────────────────
// CTA BUTTON CLICK TRACKING — for Google Ads
// Fires on primary CTA buttons
// ─────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.btn-primary[href*="pricing"], .btn-primary[href="#pricing"]').forEach(function(btn) {
    btn.addEventListener('click', function () {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'click', {
          event_category: 'CTA',
          event_label: this.textContent.trim()
        });
      }
      if (typeof fbq !== 'undefined') {
        fbq('trackCustom', 'CTAClick', { label: this.textContent.trim() });
      }
    });
  });
});

// Scroll reveal
const obs = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.style.opacity = '1';
      e.target.style.transform = 'translateY(0)';
      obs.unobserve(e.target);
    }
  });
}, { threshold: 0.08 });

document.querySelectorAll(
  '.benefit-card, .review-card, .timeline-card, .price-card, .kit-item, .who-box, .how-step, .value-list li, .faq-item'
).forEach(el => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(18px)';
  el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
  obs.observe(el);
});

// Active nav highlight on scroll
window.addEventListener('scroll', () => {
  document.querySelectorAll('section[id]').forEach(sec => {
    const top = sec.offsetTop - 110;
    const bottom = top + sec.offsetHeight;
    if (window.scrollY >= top && window.scrollY < bottom) {
      document.querySelectorAll('.nav-links a').forEach(l => l.style.color = '');
      const a = document.querySelector(`.nav-links a[href="#${sec.id}"]`);
      if (a) a.style.color = 'var(--gold)';
    }
  });
});
